import React, { Component } from "react";

import ClientAPI from "../service/ClientAPI";
import AdminAPI from "../service/AdminAPI";
import LocalStorageManager from "../managers/LocalStorageManager";
import AllProductsTable from "../components/AllProductsTable";
import CreateProductPopup from "../components/CreateProductPopup";
import { Box, Paper, TextField, InputAdornment, Button } from "@mui/material";
import { Search, Add } from '@mui/icons-material';

class DashboardAlleProdukte extends Component {
    constructor(props) {
        super(props);

        this.state = {
            products: [],
            allOrders: [],
            searchUserInTable: null,
            searchProduct: null,
            searchUser: null,
            userOrders: [],
            createProduct: false,
            createUser: false,
            showDateTable: false,
            updateStartDate: false,
            updateEndDate: false,
            startDate: props.start,
            endDate: props.end,
            downloadingExcel: false
        };

        this.isAdmin = LocalStorageManager.Get("admin") === "1";
    }

    componentDidMount() {
        if (!this.isAdmin) {
            ClientAPI.GetOrders()
                .then((_orders) => {
                    this.setState({ userOrders: _orders });
                })
                .catch(console.error);

            return;
        }

        ClientAPI.RequestProducts()
            .then((_data) => {
                AdminAPI.FetchUserOrders()
                    .then(_allOrders => {
                        ClientAPI.GetOrders()
                            .then(_orders => {
                                this.setState({ products: _data, allOrders: _allOrders, userOrders: _orders })
                            })
                    })
                    .catch(console.error);
            })
            .catch(console.error);
    }

    handleProductsReordered = (reorderedProducts) => {
        // Update parent state with reordered products
        this.setState({ products: reorderedProducts });
    }

    render() {
        return (
                <div style={{ minHeight: "95vh", paddingBottom: window.innerWidth < 600 ? "40px" : "80px" }}>
                    <h3 id="products" style={{ 
                        marginBottom: window.innerWidth < 600 ? "16px" : "20px", 
                        textAlign: "center", 
                        marginTop: window.innerWidth < 600 ? "20px" : "35px",
                        fontSize: window.innerWidth < 600 ? "1.5rem" : window.innerWidth < 900 ? "1.8rem" : "2.2rem",
                        fontWeight: 700,
                        color: "#2e7d32",
                        padding: window.innerWidth < 600 ? "0 16px" : "0"
                    }}>
                        Übersicht aller Produkte
                    </h3>
                    <div style={{ maxWidth: window.innerWidth < 600 ? "95%" : "80%", margin: "auto" }}>
                        <Paper 
                            elevation={3} 
                            sx={{ 
                                p: { xs: 1.5, sm: 2.5 }, 
                                mb: { xs: 2, sm: 3 }, 
                                bgcolor: "white",
                                borderRadius: 3,
                                boxShadow: "0 4px 16px rgba(0, 0, 0, 0.08)"
                            }}
                        >
                            <Box sx={{ display: "flex", flexDirection: { xs: 'column', sm: 'row' }, gap: 2, alignItems: { xs: 'stretch', sm: 'center' }, justifyContent: "space-between" }}>
                                <TextField
                                    size="medium"
                                    placeholder="Suche nach Produkt (Name)"
                                    value={this.state.searchProduct || ''}
                                    onChange={(e) => this.setState({ searchProduct: e.target.value })}
                                    fullWidth={window.innerWidth < 600}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Search sx={{ color: "#2e7d32" }} />
                                            </InputAdornment>
                                        ),
                                    }}
                                    sx={{ 
                                        minWidth: { xs: '100%', sm: 250 }, 
                                        flex: { xs: 1, sm: 1 },
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '10px',
                                            '&:hover fieldset': {
                                                borderColor: '#2e7d32',
                                            },
                                            '&.Mui-focused fieldset': {
                                                borderColor: '#2e7d32',
                                            },
                                        }
                                    }}
                                />
                                <Button 
                                    variant="contained"
                                    startIcon={<Add />}
                                    onClick={() => this.setState({ createProduct: true })}
                                    fullWidth={window.innerWidth < 600}
                                    sx={{
                                        bgcolor: '#2e7d32',
                                        fontWeight: 600,
                                        textTransform: 'none',
                                        fontSize: { xs: '0.9rem', sm: '1rem' },
                                        px: { xs: 2, sm: 3 },
                                        py: { xs: 1, sm: 1.2 },
                                        borderRadius: '10px',
                                        '&:hover': {
                                            bgcolor: '#1b5e20'
                                        }
                                    }}
                                >
                                    Produkt hinzufügen
                                </Button>
                            </Box>
                        </Paper>
                        <AllProductsTable 
                            maxProducts={this.state.products.length} 
                            products={this.state.products.filter(_product => this.state.searchProduct ? `${_product.Name}`.toLowerCase().includes(this.state.searchProduct.toLowerCase()) : true)} 
                            isFiltered={!!this.state.searchProduct}
                            onProductsReordered={this.handleProductsReordered}
                        />
                    </div>
                    <CreateProductPopup show={this.state.createProduct} products={this.state.products} onClose={() => this.setState({ createProduct: false })} />
                </div>
        )
    }
}

export default DashboardAlleProdukte;